// extracted by mini-css-extract-plugin
export var container = "_re-0";
export var table = "_re-2";
export var tableWrapper = "_re-1";